export default __webpack_public_path__ + "static/media/orange_logo.d25a0005.png";